import { Button } from '@/components/ui/button';
import { ObjectCard, type CardField } from '@/components/ui/ObjectCard';
import { UniversalWindow } from '@/components/ui/UniversalWindow';
import type { AutoFieldDef } from '@/components/autoforms/AutoFormContent';

// ============================================================================
// ObjectCardView — вид объекта «Карточка» (как в 1С): просмотр полей записи по
// важности (поля в карточке — раскладка ObjectCard), кнопка «Редактировать» →
// обычная форма. Вынесено из AutoObjectForm (E2e12). ЧИСТО отображательный.
// ============================================================================

interface ObjectCardViewProps {
  fields: AutoFieldDef[];
  data: Record<string, any>;
  formTitle: string;
  inline: boolean;
  maximized?: boolean;
  pos?: { x: number; y: number };
  onGeometryChange: (g: { maximized?: boolean; pos?: { x: number; y: number } }) => void;
  onEdit: () => void;
  onClose: () => void;
}

const SYSTEM_SKIP = ['created_at', 'updated_at', 'created_by', 'updated_by', 'is_marked', 'is_posted', 'posted_at'];

export function ObjectCardView({ fields, data, formTitle, inline, maximized, pos, onGeometryChange, onEdit, onClose }: ObjectCardViewProps) {
  const cardFields: CardField[] = fields
    .filter((f) => f.code && !SYSTEM_SKIP.includes(f.code))
    // Скрытые по умолчанию (как в 1С) в карточке не выводятся — только явный макет
    .filter((f) => !f.hiddenByDefault && !(f as any).hidden_by_default)
    .map((f) => ({
      name: f.code as string,
      synonym: f.synonym || f.name || f.code,
      dataType: f.dataType || f.data_type || 'text',
      importance: Number((f as any).importance) || 3,
      format: (f as any).format || '',
      refTable: f.refTable || (f as any).refCatalogCode || '',
    }));
  const presentations: Record<string, string> = {};
  for (const f of fields) {
    const p = f.code ? data[`${f.code}_presentation`] : undefined;
    if (p !== undefined && p !== null) presentations[`${f.code}_presentation`] = String(p);
  }
  return (
    <UniversalWindow
      open
      onClose={onClose}
      title={formTitle}
      modal={!inline}
      blocking={false}
      initialMaximized={maximized}
      initialPos={pos}
      onGeometryChange={onGeometryChange}
      topBar={
        <div className="flex items-center gap-2">
          <Button size="sm" variant="outline" onClick={onEdit}>Редактировать</Button>
        </div>
      }
    >
      <div className="p-3">
        <ObjectCard fields={cardFields} data={data} presentations={presentations} variant="card" />
      </div>
    </UniversalWindow>
  );
}
